import { TunnelDataContext } from "../../../digital-journey/context/TunnelDataContext"
import React, { useContext } from "react"

const RetailLogo = ({ sourceImg, alt }) => {
  const { tunnelData } = useContext(TunnelDataContext)

  return <img src={sourceImg} alt={alt} {...(tunnelData.isJourneyResumedAtHome ? {} : { className: "pointer" })} />
}

export default RetailLogo
